import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  title: string;
  isRequired: boolean;
  style?: React.CSSProperties;
}
const RequiredStar: React.FC<Props> = ({ title, isRequired, style }) => {
  const isRtl = useIsRtl();
  return (
    <div
      className="builder-item-label"
      style={{ ...style }}
      dir={isRtl ? "rtl" : "ltr"}
    >
      {title}
      {isRequired && <strong className="text-danger"> * </strong>}
    </div>
  );
};

export default RequiredStar;
